import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../config/api"; // update as needed

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState({
    loading: true,
    success: null,
    message: "",
  });
  const [countdown, setCountdown] = useState(3);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    const token = params.get("token");

    if (!token) {
      setStatus({
        loading: false,
        success: false,
        message: "Invalid verification link.",
      });
      return;
    }

    async function fetchData() {
      try {
        const res = await axios.get(
          `${API_BASE_URL}auth/verify-email?token=${token}`
        );
        if (mounted) {
          setStatus({ loading: false, success: true, message: res.data.msg });
        }
      } catch (err) {
        const msg = err.response?.data?.msg || "Verification failed.";
        if (mounted) {
          setStatus({ loading: false, success: false, message: msg });
        }
      }
    }

    fetchData();

    return () => {
      mounted = false;
    };
  }, [params]);

  // Countdown effect (runs after status.success is true)
  useEffect(() => {
    if (status.success) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(timer);
            navigate("/signin");
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [status.success, navigate]);

  return (
    <div className="container py-5" style={{ maxWidth: "600px" }}>
      <div className="text-center">
        <h2 className="mb-3">Verifying your email...</h2>
        {status.loading && <div className="spinner-border text-primary" />}
        {!status.loading && (
          <div
            className={`alert alert-${status.success ? "success" : "danger"}`}
          >
            {status.message}
          </div>
        )}
        {!status.loading && status.success && (
          <p className="text-muted">
            Redirecting to login in {countdown} second{countdown !== 1 && "s"}...
          </p>
        )}
      </div>
    </div>
  );
}
